import React, { useEffect, useState } from "react";
import { Button, Table } from "antd"; // Import Table from Ant Design

function FlourMillDetails({ allData }) {
  console.log(allData)
  const [data, setData] = useState([]);
  // const [dataLimit, setDataLimit] = useState({});

  useEffect(() => {
    setData(allData);
    // Initialize the dataLimit to show the first 3 items and "View All" button by default
   
    // setDataLimit(initialLimits);
  }, []);

  // const handleViewAll = (index) => {
  //   setDataLimit((prevLimits) => ({
  //     ...prevLimits,
  //     [index]: prevLimits[index] === 3 ? data[index].items.length : 3,
  //   }));
  // };

  // Define columns for the items table
  const itemsColumns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Daily Grind",
      dataIndex: "dailyGrind",
    },
    {
      title: "Daily Running Hours",
      dataIndex: "dailyRunningHours",
    },
    {
      title: "Time Consuming",
      dataIndex: "timeConsuming",
    },
    {
      title: "Grind Price",
      dataIndex: "grindPrice",
    },
    {
      title: "Gross Income",
      dataIndex: "grossIncome",
    },
    // Add other columns as needed
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="col-12 mb-4">
              <h5 className="card-title">{item?.flourMill?.name}</h5>
              <p>Working Days: {item?.flourMill?.workingDays}</p>
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="text-danger">Items</h5>
                  {item.items && item.items.length > 0 ? (
                    <div className="table-responsive mb-4">
                      <Table
                        dataSource={item.items}
                        columns={itemsColumns}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                      {/* {item.items.length > 3 && (
                        <Button onClick={() => handleViewAll(index)} block>
                          {dataLimit[index] === 3 ? "View All" : "Show Less"}
                        </Button>
                      )} */}
                    </div>
                  ) : (
                    <div className="border rounded p-4 mb-2">
                      <p>No items available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 mb-4">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FlourMillDetails;
